import {
  blueColorScheme,
  ButtonSVGProps,
  ButtonSVGType,
  normalShortColorScheme
} from '@src/constants/variant'
import { useMemo } from 'react'

const ShortButtonSVG = ({ style }: ButtonSVGProps) => {
  const colorScheme = useMemo(() => {
    if (style === ButtonSVGType.Blue) {
      return blueColorScheme
    }

    return normalShortColorScheme
  }, [style])

  return (
    <svg
      className='blue'
      width='170'
      height='43'
      viewBox='0 0 170 43'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        id={style === ButtonSVGType.Blue ? '' : 'background'}
        fillRule={style === ButtonSVGType.Blue ? undefined : 'evenodd'}
        clipRule={style === ButtonSVGType.Blue ? undefined : 'evenodd'}
        d='M7 7H8V6V1L164 1V6V7H165H169V36H165H164V37V42H8V37V36H7H1V7H7Z'
        fill={colorScheme.pathFill}
        stroke={colorScheme.pathStroke}
        strokeWidth='2'
      />

      <rect x='9' y='8' width='6' height='6' fill={colorScheme.smallRectFill} />
      <rect
        x='154'
        y='8'
        width='6'
        height='6'
        fill={colorScheme.smallRectFill}
      />
      <rect
        x='9'
        y='29'
        width='6'
        height='6'
        fill={colorScheme.smallRectFill}
      />
      <rect
        x='154'
        y='29'
        width='6'
        height='6'
        fill={colorScheme.smallRectFill}
      />

      <rect
        x='141.414'
        y='22'
        width='10'
        height='10'
        transform='rotate(-45 141.414 22)'
        fill={colorScheme.rectFill}
        stroke={colorScheme.rectStroke}
        strokeWidth='2'
      />
      <rect
        x='13.4142'
        y='22'
        width='10'
        height='10'
        transform='rotate(-45 13.4142 22)'
        fill={colorScheme.rectFill}
        stroke={colorScheme.rectStroke}
        strokeWidth='2'
      />
    </svg>
  )
}

export default ShortButtonSVG
